import { jsx as m, Fragment as k } from "react/jsx-runtime";
import { useCallback as h } from "react";
import { useSupercluster as I } from "../../../hooks/use-supercluster.js";
import { isArrayWithItems as u } from "../../../../../helpers/array-helper.js";
import "dayjs";
import { MapClusterWrapper as M } from "../station-markers/map-cluster-wrapper/map-cluster-wrapper.js";
import { MapMarkerWrapper as B } from "../station-markers/map-marker-wrapper/map-marker-wrapper.js";
import { useTranslation as O } from "react-i18next";
import { orderBy as b } from "lodash-es";
import { getMarkerTypeForStation as C } from "../../../helpers/marker-helper.js";
const E = (c) => {
  const r = [];
  for (let o of c) {
    const n = C(o.properties.station), e = r.find(
      (s) => s.markerType === n
    );
    if (e)
      e.numberOfStations = e.numberOfStations + 1, u(o.properties.station.electricConnectors) && (e.hasElectricalCharging = !0);
    else {
      const s = {
        markerType: n,
        numberOfStations: 1,
        hasElectricalCharging: !!u(o.properties.station.electricConnectors)
      };
      r.push(s);
    }
  }
  return b(r, ["markerType"], ["desc"]);
}, _ = {
  extent: 256,
  radius: 80,
  maxZoom: 12,
  minZoom: 6,
  minPoints: 3
}, D = ({
  stations: c,
  selectedStation: r,
  onClickCluster: i,
  onClickStation: o
}) => {
  const { clusters: n, getClusterExpansionZoom: e, getLeaves: s } = I(c, _), { t: y } = O(), T = h(
    (t, a) => {
      const p = e(t);
      typeof i == "function" && i(p, a);
    },
    [i, e]
  );
  return /* @__PURE__ */ m(k, { children: n.map((t) => {
    const [a, p] = t.geometry.coordinates, l = t.properties;
    if (l.cluster) {
      const S = s(l.cluster_id), g = E(S);
      return /* @__PURE__ */ m(
        M,
        {
          title: y("FIND_STATION_MAP_CLUSTER_LABEL"),
          stationsInClusterByType: g,
          clusterId: l.cluster_id,
          position: { lat: p, lng: a },
          onClickMarker: T
        },
        t.id
      );
    }
    const f = C(t.properties.station), d = r?.stationCode;
    return /* @__PURE__ */ m(
      B,
      {
        title: t.properties.station.stationName,
        isSelected: !!(d && d === t.properties.station.stationCode),
        stationCode: t.id,
        position: { lat: p, lng: a },
        markerType: f,
        hasElectricalCharging: u(t.properties.station.electricConnectors),
        onClickMarker: o
      },
      t.id
    );
  }) });
};
export {
  D as ClusteredMarkers
};
